import { createSelector } from "reselect";
import { getDischargeSteps, getCurrentModuleSlug, getCurrentTopicSlug } from "./core";
import { getCurrentProgress, buildCompletedIdSet } from "./progress";

const EMPTY_ARRAY = [];

const mapStepToProgress = (step, progress, completedIdSet) => {
  const targetStepId = String(step.ID || step.id);

  const topics = Array.isArray(step.topics) ? step.topics : [];
  
  let completedCount = 0;
  const stepCompletedTopics = topics.map(topic => {
    const currentTopicId = String(topic.ID || topic.id);
    const completed = completedIdSet.has(currentTopicId);
    if (completed) completedCount++;
    return { ...topic, completed };
  });

  return {
    ...step,
    topics: stepCompletedTopics,
    completion: topics.length > 0 ? (completedCount / topics.length) * 100 : 0
  };
};

export const getDischargeProgress = createSelector(
  [getDischargeSteps, getCurrentProgress],
  (steps, progress) => {
    if (!Array.isArray(steps)) return EMPTY_ARRAY;
    // Build the Set once for all steps instead of per-topic inside each step
    const completedIdSet = buildCompletedIdSet(progress);
    return steps.map(step => mapStepToProgress(step, progress, completedIdSet));
  }
);

export const getDischargeFullyComplete = createSelector(
  [getDischargeProgress], 
  steps => steps.length > 0 ? steps.every(s => s.completion === 100) : false
);

export const getCurrentDischargeStepProgress = createSelector(
  [getDischargeProgress, getCurrentModuleSlug],
  (steps, slug) => steps[parseInt(slug, 10) - 1] || null
);

export const getCurrentDischargeStepTopicProgress = createSelector(
  [getCurrentDischargeStepProgress, getCurrentTopicSlug],
  (step, slug) => {
    if (!step || !Array.isArray(step.topics)) return null;
    const topic = step.topics[parseInt(slug, 10)];
    return topic ? { ...topic, lastTopic: parseInt(slug, 10) === step.topics.length - 1 } : null;
  }
);
